export const ACCESS_SCOPE_STORAGE_KEY = "journey-access-scope";
export const CAPABILITIES_STORAGE_KEY = "journey-capabilities";
export const BOOKING_OWNER_CONTEXT_STORAGE_KEY = "booking-owner-context";

const DEFAULT_CAPABILITIES = {
  onlineCheckin: true,
  checkout: true,
  payment: true,
  invoice: true,
  doorAccess: true,
  directory: true,
  support: true,
};

const capabilityValue = (source, camelKey, snakeKey = camelKey) => {
  if (!source || typeof source !== "object") {
    return undefined;
  }

  if (Object.prototype.hasOwnProperty.call(source, camelKey)) {
    return source[camelKey];
  }

  if (Object.prototype.hasOwnProperty.call(source, snakeKey)) {
    return source[snakeKey];
  }

  return undefined;
};

export const normalizeCapabilities = (capabilities = {}) => ({
  onlineCheckin: capabilityValue(capabilities, "onlineCheckin", "online_checkin") !== false,
  checkout: capabilityValue(capabilities, "checkout") !== false,
  payment: capabilityValue(capabilities, "payment") !== false,
  invoice: capabilityValue(capabilities, "invoice") !== false,
  doorAccess: capabilityValue(capabilities, "doorAccess", "door_access") !== false,
  directory: capabilityValue(capabilities, "directory") !== false,
  support: capabilityValue(capabilities, "support") !== false,
});

export const storeJourneyAccess = (data = {}) => {
  const accessScope = String(data.access_scope || data.accessScope || "").trim().toUpperCase();
  const capabilities = normalizeCapabilities(data.capabilities || {});

  localStorage.setItem(ACCESS_SCOPE_STORAGE_KEY, accessScope);
  localStorage.setItem(CAPABILITIES_STORAGE_KEY, JSON.stringify(capabilities));

  return { accessScope, capabilities };
};

export const getStoredAccessScope = () =>
  String(localStorage.getItem(ACCESS_SCOPE_STORAGE_KEY) || "").trim().toUpperCase();

export const getStoredCapabilities = () => {
  try {
    return {
      ...DEFAULT_CAPABILITIES,
      ...JSON.parse(localStorage.getItem(CAPABILITIES_STORAGE_KEY) || "{}"),
    };
  } catch {
    return { ...DEFAULT_CAPABILITIES };
  }
};

export const canUseCapability = (capability) =>
  getStoredCapabilities()[capability] !== false;

export const isRoomGuestJourney = () => getStoredAccessScope() === "ROOM_GUEST";

export const setBookingOwnerContext = (context = {}) => {
  localStorage.setItem(BOOKING_OWNER_CONTEXT_STORAGE_KEY, JSON.stringify(context));
};

export const getBookingOwnerContext = () => {
  try {
    return JSON.parse(localStorage.getItem(BOOKING_OWNER_CONTEXT_STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
};

export const clearBookingOwnerContext = () => {
  localStorage.removeItem(BOOKING_OWNER_CONTEXT_STORAGE_KEY);
};
